<div class="container h-100 login-wrapper login-container">
  <div class="row h-100 pt-5">
    <div class="col" [ngClass]="{ 'handset-center-login': isHandset }">
      @if (!isHandset) {
        <div class="row">
          <div class="col">
            <mat-icon
              svgIcon="logo-horizontal"
              class="login-vivacom-logo"
            ></mat-icon>
          </div>
        </div>
      }
      @if (isHandset) {
        <div class="position-fixed mt-3 w-100" style="top: 0">
          <div class="text-center">
            <mat-icon
              svgIcon="logo-horizontal"
              class="login-vivacom-logo mr-4"
            ></mat-icon>
          </div>
        </div>
      }
      @if (!isHandset) {
        <div class="row">
          <div class="col text-center">
            <!--                    <mat-icon svgIcon="vivacom-smart-iot-logo" [style]="{'height': '50px', 'width': '370px'}"></mat-icon>-->
            <strong class="text-white" style="font-size: 50px">Vivacom Smart IoT</strong>
          </div>
        </div>
      }
      @if (!isHandset) {
        <div class="row">
          <div class="col text-center">
              <div class="light-strip mr-5" ></div>
          </div>
        </div>
      }
      @if (!isHandset) {
        <div class="row">
          <div class="col text-center">
            <div
              class="text-white mb-5 login-welcome-txt"
              [innerHTML]="'login.welcome_text' | transloco"
            ></div>
          </div>
        </div>
      }
      <div class="row" [ngClass]="{ 'h-100': isHandset }">
        <div
          class="col text-center"
          [ngClass]="{ 'handset-center-login': isHandset }"
          >
          <mat-card class="d-inline-block">
            <mat-card-header class="login-header">
              @if (!isHandset) {
                <mat-icon
                  svgIcon="vivacom-iot-logo"
                  class="mb-3"
                  [style]="{ height: '65px', width: '65px' }"
                ></mat-icon>
              }
              @if (isHandset) {
                <mat-icon
                  svgIcon="vivacom-iot-logo"
                  class="mb-3"
                  [style]="{ height: '75px', width: '75px' }"
                ></mat-icon>
              }
              <!--                <mat-icon svgIcon="vivacom-smart-iot-logo" [style]="{'height': '120px', 'width': '250px'}"></mat-icon>-->
              @if (!isHandset) {
                <h1 class="login-text">
                  {{ "operations.login" | transloco }}
                </h1>
              }
            </mat-card-header>
            <mat-card-content>
              <form
                [formRoot]="loginForm"
                (keyup.enter)="login()"
                >
                <mat-form-field
                  class="example-full-width loren-form-field"
                  >
                  <mat-label>{{ "login.username" | transloco }}</mat-label>
                  <input
                    matInput
                    [formField]="loginForm.username"
                    />
                </mat-form-field>
                <mat-form-field
                  class="example-full-width loren-form-field"
                  >
                  <mat-label>{{ "login.password" | transloco }}</mat-label>
                  <input
                    matInput
                    [formField]="loginForm.password"
                    type="password"
                    />
                </mat-form-field>
                @if (loginFailureMessageKey()) {
                  <div class="text-danger">
                    {{ loginFailureMessageKey() | transloco }}
                  </div>
                }
              </form>
            </mat-card-content>
            <mat-checkbox class="float-left mb-3" [formField]="loginForm.rememberMe">
              {{ "operations.remember_me" | transloco }}
            </mat-checkbox>
            <div class="w-100 text-center">
              <button
                class="w-100 text-white"
                matButton="filled"
                [disabled]="submitting()"
                (click)="login()"
                color="accent"
                >
                {{ "operations.login" | transloco }}
              </button>
              <br />
            </div>
            <div class="w-100 text-center mt-3">
              <a
                [routerLink]="['/forgotten-password']"
                class="mt-3 text-black-50"
                href="#"
                >{{ "features.forgotten_password" | transloco }}?</a
                >
              </div>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </div>
